export const COLORS = {
  primary: '#712776',
  darker: '#6B1273',
  teal: '#059885',
  lightGray: '#F2F4F7',
  darkerGray: '#646777'
}
